import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appDetailOrden]'
})
export class DetailOrdenDirective {
  @Input() set data(value){
    if(value){
      this.el.nativeElement.innerHTML = value;
    }
  }

  constructor(private el: ElementRef<HTMLDivElement>) { }

}
